import get from 'lodash/get'

import { WIZARD_TYPE_PAGE, WIZARD_TYPE_SURVEY } from '@client/components/Editor/settings'
import storage from './Storage'
import { ganApi } from '@client/api'

export const loadItemByType = async (id, wizardType, type) => {
  if (id) {
    const load = ganApi.getFetchMethodByType(wizardType, type)
    const item = await load(id)

    let itemInfo
    if (wizardType === WIZARD_TYPE_PAGE || wizardType === WIZARD_TYPE_SURVEY) {
      const loadInfo = ganApi.getFetchInfoMethodByType(wizardType)
      itemInfo = await loadInfo(id)
    }
    if (item && wizardType) {
      item.hash = id
      item.kind = type
      item.status = get(itemInfo, 'status')
    }
    storage.saveItem(item)
  }

  return storage.getItem()
}
